import { render, staticRenderFns } from "./VuesticAccordion.vue?vue&type=template&id=5d47ca68&"
import script from "./VuesticAccordion.vue?vue&type=script&lang=js&"
export * from "./VuesticAccordion.vue?vue&type=script&lang=js&"
import style0 from "./VuesticAccordion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VuesticAccordion.vue"
export default component.exports